import { useApi } from './useApi';

const SESSION_API_ERROR_CODE = 'auth/session-api';

export function useSessionApi() {
    const { callApi, ApiMethod } = useApi();

    async function loginToSession(firebaseUser) {
        return await callSessionApi(firebaseUser, ApiMethod.POST, 'login');
    }

    async function getCustomTokenForExistingSession() {
        const response = await callSessionApi(null, ApiMethod.GET, 'status');
        return await response.json();
    }

    async function logoutOfSession() {
        return await callSessionApi(null, ApiMethod.POST, 'logout');
    }

    async function sendSignInLinkToEmail(email, continueToProduct) {
        return await callSessionApi(null, ApiMethod.POST, 'signInLink', {
            email: email,
            continueToProduct: continueToProduct,
        });
    }

    async function sendResetPasswordLinkToEmail(email, continueToProduct, continueToAccounts) {
        return await callSessionApi(null, ApiMethod.POST, 'resetPasswordLink', {
            email: email,
            continueToProduct: continueToProduct,
            continueToAccounts: continueToAccounts,
        });
    }

    async function callSessionApi(user, method, endpoint, bodyParams) {
        try {
            return await callApi(user, method, `/session-api/${endpoint}`, bodyParams, true);
        } catch (error) {
            error.code = error.code || SESSION_API_ERROR_CODE;
            throw error;
        }
    }

    return {
        loginToSession,
        getCustomTokenForExistingSession,
        logoutOfSession,
        sendSignInLinkToEmail,
        sendResetPasswordLinkToEmail,
    };
}
